(function() {
'use strict';

angular
    .module('TR')
    .directive('agentAutofill', AgentAutofill);

function AgentAutofill(agentModeService, resourceService) {
    return {
        restrict: 'E',
        require: '?ngModel',
        scope: {
            booking: '='
        },
        templateUrl: (element, attr) => {
            if (attr.templateVersion) {
                return `partials/booking/template?name=Agent/AgentAutofillDirective&version=${attr.templateVersion}`;
            }
            return 'partials/home/directivetemplate?type=AgentAutofillDirective';
        },
        link: linker
    };

    function linker(scope) {
        scope.lookup = lookup;

        function lookup(bookingId) {
            scope.errorMessage = undefined;
            agentModeService.getBookingContact(bookingId)
            .then(fillInformations, handleErrors);
        }

        function fillInformations(bookingInfo) {
            if (TRPCONFIG.Domain.AutofillBasicContactInfo) {
                //agent mode for dnata agents needs only the following keys to be auto populated
                const basicInfoKeys = ['Title', 'FirstName', 'LastName', 'CountryCode'];
                fillBasicInformations(bookingInfo, basicInfoKeys);
                return;
            }
            fillBasicInformations(bookingInfo, Object.keys(scope.booking));
        }

        function fillBasicInformations(bookingInfo, keys) {
            keys.forEach(function(key) {
                if (bookingInfo[key]) {
                    scope.booking[key] = bookingInfo[key];
                }
            });
        }

        function handleErrors(res) {
            switch (res.status) {
                case 400:
                    scope.errorMessage = resourceService.get('AGENTBOOKINGIDINVALID');
                    break;
                case 404:
                    scope.errorMessage = resourceService.get('AGENTBOOKINGIDNOTFOUND');
                    break;
                default:
                    scope.errorMessage = resourceService.get('AGENTBOOKINGIDERROR');
                    break;
            }
        }
    }
}
})();
